export type ToothDentition = "permanent" | "primary";

export const PERMANENT_TEETH = {
  upperRight: [1, 2, 3, 4, 5, 6, 7, 8],
  upperLeft: [9, 10, 11, 12, 13, 14, 15, 16],
  lowerRight: [32, 31, 30, 29, 28, 27, 26, 25],
  lowerLeft: [24, 23, 22, 21, 20, 19, 18, 17],
} as const;

export const PRIMARY_TEETH = {
  upperRight: ["A", "B", "C", "D", "E"],
  upperLeft: ["F", "G", "H", "I", "J"],
  lowerRight: ["T", "S", "R", "Q", "P"],
  lowerLeft: ["O", "N", "M", "L", "K"],
} as const;

export const ALL_PERMANENT_TEETH = [
  ...PERMANENT_TEETH.upperRight,
  ...PERMANENT_TEETH.upperLeft,
  ...PERMANENT_TEETH.lowerLeft.slice().reverse(),
  ...PERMANENT_TEETH.lowerRight.slice().reverse(),
];

export const ALL_PRIMARY_TEETH = [
  ...PRIMARY_TEETH.upperRight,
  ...PRIMARY_TEETH.upperLeft,
  ...PRIMARY_TEETH.lowerLeft.slice().reverse(),
  ...PRIMARY_TEETH.lowerRight.slice().reverse(),
];

export function parsePermanentTooth(value: string): number | null {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed) || parsed < 1 || parsed > 32) return null;
  return parsed;
}

export function getPermanentTeethInRange(from: string, to: string): string[] {
  const fromNum = parsePermanentTooth(from);
  const toNum = parsePermanentTooth(to);
  if (fromNum === null || toNum === null) return [];

  const start = Math.min(fromNum, toNum);
  const end = Math.max(fromNum, toNum);
  const result: string[] = [];

  for (let tooth = start; tooth <= end; tooth += 1) {
    result.push(String(tooth));
  }

  return result;
}

export function getPrimaryTeethInRange(from: string, to: string): string[] {
  const fromUpper = from.toUpperCase();
  const toUpper = to.toUpperCase();
  const fromIndex = (ALL_PRIMARY_TEETH as readonly string[]).indexOf(fromUpper);
  const toIndex = (ALL_PRIMARY_TEETH as readonly string[]).indexOf(toUpper);
  if (fromIndex === -1 || toIndex === -1) return [];

  const start = Math.min(fromIndex, toIndex);
  const end = Math.max(fromIndex, toIndex);
  return ALL_PRIMARY_TEETH.slice(start, end + 1);
}
